import ApiService from '@/services/core/api.service'

const MarketingProgramService = {
  async get (query) {
    return ApiService.get(`supervisor/marketing-programs?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/marketing-programs', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/marketing-programs/${payload.id}`, payload)
  }
}

export default MarketingProgramService
